import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a090611e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "shopping-cart" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" A guest has no account, hence nothing active or in progress: only the cart\n\t\t     column is rendered, laid out by subscription-columns--cart-only. "),
    _createElementVNode("div", {
      class: _normalizeClass(["subscription-columns", { 'subscription-columns--cart-only': $setup.is_guest }])
    }, [
      (!$setup.is_guest)
        ? (_openBlock(), _createBlock($setup["SubscriptionColumn"], {
            key: 0,
            subscription: $setup.active,
            carttype: "active",
            heading: _ctx.__('Your active subscription'),
            users: $setup.number_of_users,
            onGet_subscription: _cache[0] || (_cache[0] = $event => ($setup.get_subscription()))
          }, null, 8 /* PROPS */, ["subscription", "heading", "users"]))
        : _createCommentVNode("v-if", true),
      (!$setup.is_guest)
        ? (_openBlock(), _createBlock($setup["SubscriptionColumn"], {
            key: 1,
            subscription: $setup.in_progress,
            carttype: "in-progress",
            heading: _ctx.__('Your orders in progress'),
            users: $setup.number_of_users,
            onGet_subscription: _cache[1] || (_cache[1] = $event => ($setup.get_subscription()))
          }, null, 8 /* PROPS */, ["subscription", "heading", "users"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["SubscriptionColumn"], {
        subscription: $setup.cart,
        carttype: "shopping-cart",
        heading: _ctx.__('Your cart'),
        users: $setup.number_of_users,
        onGet_subscription: _cache[2] || (_cache[2] = $event => ($setup.get_subscription()))
      }, null, 8 /* PROPS */, ["subscription", "heading", "users"])
    ], 2 /* CLASS */)
  ]))
}